var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import React from 'react';
export var useButtonStyles = makeStyles({
    button: __assign(__assign(__assign(__assign({ height: '32px', minWidth: '80px' }, shorthands.padding('4px', '8px')), { cursor: 'pointer', boxShadow: tokens.shadow8, fontSize: tokens.fontSizeBase300, lineHeight: tokens.lineHeightBase300, fontWeight: tokens.fontWeightSemibold, fontFamily: tokens.fontFamilyBase, backgroundColor: tokens.colorBrandBackground, color: tokens.colorNeutralForegroundOnBrand }), shorthands.borderColor('transparent')), { ':hover': {
            backgroundColor: tokens.colorBrandBackgroundHover,
        }, ':active': {
            backgroundColor: tokens.colorBrandBackgroundPressed,
        } }),
});
export var CustomMSButton = function () {
    var styles = useButtonStyles();
    return React.createElement("button", { className: styles.button }, "Custom Button");
};
//# sourceMappingURL=CustomMSButton.js.map